export const SUPPORT_SERVER_INVITE: string = "https://discord.gg/SMEgFNy";
export const DISCORD_BOT_INVITE: string = "https://discord.com/api/oauth2/authorize?client_id=528108872825700372&scope=bot+applications.commands&permissions=378944";
export const TERMS_OF_SERVICE: string = "https://docs.adduptime.net/en/terms-of-service";
